import { Moon, Sun } from 'lucide-react';
import { useColorTheme } from '@/ColorThemeProvider';

export default function ThemePill({ fixed = false }: { fixed?: boolean }) {
  const { isDark, setColorTheme } = useColorTheme();
  return (
    <div
      className={`flex gap-xs rounded-sm bg-background-secondary p-xs ${
        fixed ? 'fixed top-l right-l shadow-sm' : ''
      }`}
      role="group"
      aria-label="Theme"
    >
      <ThemeButton
        label="Light theme"
        pressed={!isDark}
        onClick={() => setColorTheme('light')}
      >
        <Sun size={16} />
      </ThemeButton>
      <ThemeButton
        label="Dark theme"
        pressed={isDark}
        onClick={() => setColorTheme('dark')}
      >
        <Moon size={16} />
      </ThemeButton>
    </div>
  );
}

function ThemeButton({
  label,
  pressed,
  onClick,
  children,
}: {
  label: string;
  pressed: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      className={`flex size-8 cursor-pointer items-center justify-center rounded-xs transition-colors ${
        pressed ?
          'bg-background-main text-purple-default'
        : 'text-gray hover:text-purple-default'
      }`}
      aria-label={label}
      aria-pressed={pressed}
      title={label}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
